import Loader from 'components/atoms/loader';
import Backstage from 'interfaces/Backstage.interface';
import NftData from 'interfaces/NftData.interface';
import { UserData } from 'interfaces/UserData.interface';
import React from 'react';
import ResultRow, { ResultType } from './ResultRow';

interface IResultProps {
  posts: Backstage[];
  users: UserData[];
  nfts: NftData[];
  loading: boolean;
}

const Results = ({ posts, users, nfts, loading }: IResultProps) => {
  const user0 = require('assets/Profile/buku_default_avatar.png');

  return (
    <div className="container-result">
      {loading ? (
        <Loader color={'#D8B72E'} size={'1.8'} />
      ) : posts.length === 0 && users.length === 0 && nfts.length === 0 ? (
        <h3>No results found</h3>
      ) : (
        <>
          <div className="container-child">
            {users.length > 0 && (
              <div className="list-container">
                <h4>Profiles</h4>
                <ul>
                  {users.map(user => (
                    <ResultRow
                      key={user.id}
                      avatar={user.avatar || user0}
                      title={user.name || user.username}
                      desc={`@${user.username}`}
                      isUser={true}
                      type={ResultType.user}
                      user={user}
                    />
                  ))}
                </ul>
              </div>
            )}
            {posts.length > 0 && (
              <div className="list-container">
                <h4>Posts</h4>
                <ul>
                  {posts.map(post => (
                    <ResultRow
                      key={post.id}
                      avatar={(post.images && post.images[0]) || user0}
                      title={post.content || ''}
                      desc={`@${post.user?.username}`}
                      isUser={false}
                      type={ResultType.post}
                      post={post}
                    />
                  ))}
                </ul>
              </div>
            )}
            {nfts.length > 0 && (
              <div className="list-container">
                <h4>NFTs</h4>
                <ul>
                  {nfts.map(nft => (
                    <ResultRow
                      key={nft.id}
                      avatar={nft.poster}
                      title={nft.title}
                      desc={nft.description}
                      isUser={false}
                      type={ResultType.nft}
                      nft={nft}
                    />
                  ))}
                </ul>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Results;
